import { getWithIDToken, IMSTokenParams } from "@utils/http/MSAuthAPI";

interface IFeatureFlagService {
    getFeatureFlag(flagName: string, IDTokenParams: IMSTokenParams): Promise<boolean>;
}

const FeatureFlagService: IFeatureFlagService = {
    async getFeatureFlag(
        flagName: string,
        IDTokenParams: IMSTokenParams,
    ): Promise<boolean> {
        const resp = await getWithIDToken(
            "/v1/feature-flags",
            IDTokenParams,
            { flag_name: flagName },
        );

        return resp.data.value;
    },
};

export default FeatureFlagService;

